import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//For Google Analytics https://matteo-gabriele.gitbook.io/vue-gtag/
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'UA-29361566-3' }
}, router)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
